/**
 * Created by pajicv on 10/26/18.
 */
import React from 'react';
import { Typography, withStyles } from '@material-ui/core';
import ProjectCycles from '../Cycles/ProjectCycles.enhancer';
import CyclesBar from '../Cycles/CyclesBar';
import classnames from 'classnames';
import { copyCycle } from '../../firebase/db';

const styles = theme => ({
    page: {
        margin: "10px 100px 5px 100px"
    }
});

class CyclesOverlay extends React.Component {

    state = {
        isCreatingCycle: false
    };

    handleCycleClick = (selectedCycle) => {
        const { onCycleSelect } = this.props;
        onCycleSelect(selectedCycle);
    };

    handleTaskClick = (selectedTask) => {
        const { onTaskSelect } = this.props;
        onTaskSelect(selectedTask);
    };

    handleAddNewCycleClick = () => {
        const { cycles, projectId, auth, onCycleSelect } = this.props;
        const numberOfCycles = Object.keys(cycles).length;
        const activeCycleId = Object.keys(cycles).pop();
        this.setState({ isCreatingCycle: true });
        copyCycle(projectId, activeCycleId, numberOfCycles, auth.email)
            .then((newCycleId) => {
                this.setState({ isCreatingCycle: false });
                onCycleSelect(newCycleId);
            });
    };

    handleDeleteCycle = () => {
        const { cycles, onCycleDelete } = this.props;
        onCycleDelete(cycles);
    };

    render() {
        const { cycles, classes, project, cycleId, subTaskAssigned, onCycleDelete} = this.props;
        const { isCreatingCycle } = this.state;
        const selectedCycleIndex = cycles[cycleId].index;
        const numberOfCycles = Object.keys(cycles).length;

        let renderedCycles = <Typography>There are no cycles in project</Typography>;
        if (numberOfCycles >= 1) {
            renderedCycles = (
                    <div className={classes.page}>
                        <CyclesBar
                            selectedCycle={cycleId}
                            projectTitle={project.title}
                            cycles={cycles}
                            onCycleClick={this.handleCycleClick}
                            isCreatingCycle={isCreatingCycle}
                            onAddCycle={this.handleAddNewCycleClick}
                        />
                        <ProjectCycles
                            key={cycleId}
                            subTaskAssigned={subTaskAssigned}
                            cycleId={cycleId}
                            projectTitle={project.title}
                            index={selectedCycleIndex}
                            onTaskClick={this.handleTaskClick}
                            onCycleDelete={this.handleDeleteCycle}
                        />
                    </div>
            );
        }
        return renderedCycles;
    }
}

export default withStyles(styles)(CyclesOverlay);


// WEBPACK FOOTER //
// ./src/components/Overlay/CyclesOverlay.js